import Swal from "sweetalert2";

export const baseUrl = process.env.REACT_APP_BASE_URL;

export const API = {
    projets: `${baseUrl}/api/Projets`,
    projet: (id) => `${baseUrl}/api/Projets/${id}`,
    dashboard: `${baseUrl}/api/Projets/dashboard`,
    dashboardComplet: `${baseUrl}/api/GestionProjets/dashboard`, 
    projetDocuments: (id) => `${baseUrl}/api/Projets/${id}/documents`,
    membres: (id) => `${baseUrl}/api/Projets/${id}/membres`,
    membre: (id, employeId) => `${baseUrl}/api/Projets/${id}/membres/${employeId}`,
    finances: (id) => `${baseUrl}/api/Projets/${id}/finances`,
    depenses: (id) => `${baseUrl}/api/Projets/${id}/depenses`,
    depense: (id, depenseId) => `${baseUrl}/api/Projets/${id}/depenses/${depenseId}`,
    projetOptions: `${baseUrl}/api/Projets/options`,
    planning: (id) => `${baseUrl}/api/Projets/${id}/planning`,
    phases: (id) => `${baseUrl}/api/Projets/${id}/phases`,
    phase: (id, phaseId) => `${baseUrl}/api/Projets/${id}/phases/${phaseId}`,
    movePhase: (id, phaseId, dir) => `${baseUrl}/api/Projets/${id}/phases/${phaseId}/move/${dir}`,
    taches: (id) => `${baseUrl}/api/Projets/${id}/taches`,
    tache: (id, tacheId) => `${baseUrl}/api/Projets/${id}/taches/${tacheId}`,
    tacheSuivi: (id, tacheId) => `${baseUrl}/api/Projets/${id}/taches/${tacheId}/suivi`,
    tachesGlobal: `${baseUrl}/api/Taches`,
    journal: (id) => `${baseUrl}/api/Projets/${id}/journal`,
    journalEntry: (id, entryId) => `${baseUrl}/api/Projets/${id}/journal/${entryId}`,
    journalPhotos: (id, entryId) => `${baseUrl}/api/Projets/${id}/journal/${entryId}/photos`,
    journalPhoto: (id, entryId, docId) => `${baseUrl}/api/Projets/${id}/journal/${entryId}/photos/${docId}`,
    gedFolders: `${baseUrl}/api/ged/folders`,
    gedUpload: `${baseUrl}/api/ged/documents/upload`,
    documentProjets: `${baseUrl}/api/DocumentProjets`,
    suppliers: `${baseUrl}/api/Suppliers`,
    employes: `${baseUrl}/api/Employes`,
    employe: (id) => `${baseUrl}/api/Employes/${id}`,
    clients: `${baseUrl}/api/Clients`,
    preview: (id) => `${baseUrl}/api/ged/documents/${id}/preview`,
    download: (id) => `${baseUrl}/api/ged/documents/${id}/download`,
};

// Routes du front (à aligner sur Content.js)
export const ROUTES = {
    dashboard: "/projets",
    liste: "/projets/liste",
    fiche: (id) => `/projets/fiche/${id}`,
    employes: "/projets/employes",
    taches: "/projets/taches",
    RapportsProjets: "/projets/RapportsProjets",
};

// ---- Enums de l'API (valeur numérique ou nom, selon la sérialisation JSON) ----
export const TYPES = [
    { value: 1, name: "Chantier", label: "Chantier", icon: "fa-hard-hat", css: "badge-warning", color: "#f0ad4e" },
    { value: 2, name: "Vente", label: "Vente", icon: "fa-handshake", css: "badge-success", color: "#28a745" },
    { value: 3, name: "Interne", label: "Interne", icon: "fa-building", css: "badge-info", color: "#17a2b8" },
    { value: 4, name: "Autre", label: "Autre", icon: "fa-folder", css: "badge-secondary", color: "#6c757d" },
];
export const STATUTS = [
    { value: 3, name: "Brouillon", label: "Brouillon", css: "badge-light", color: "#adb5bd" },
    { value: 4, name: "Planifie", label: "Planifié", css: "badge-info", color: "#17a2b8" },
    { value: 1, name: "EnCours", label: "En cours", css: "badge-primary", color: "#007bff" },
    { value: 5, name: "Suspendu", label: "Suspendu", css: "badge-warning", color: "#ffc107" },
    { value: 2, name: "Termine", label: "Terminé", css: "badge-success", color: "#28a745" },
    { value: 6, name: "Annule", label: "Annulé", css: "badge-dark", color: "#343a40" },
];
export const PRIORITES = [
    { value: 1, name: "Basse", label: "Basse", css: "text-muted", icon: "fa-arrow-down" },
    { value: 2, name: "Normale", label: "Normale", css: "text-secondary", icon: "fa-minus" },
    { value: 3, name: "Haute", label: "Haute", css: "text-danger", icon: "fa-arrow-up" },
];
export const ETAPES_VENTE = [
    { value: 1, name: "Prospection", label: "Prospection" },
    { value: 2, name: "Offre", label: "Offre envoyée" },
    { value: 3, name: "Negociation", label: "Négociation" },
    { value: 4, name: "Gagne", label: "Gagné" },
    { value: 5, name: "Perdu", label: "Perdu" },
];

export const STATUTS_TACHE = [
    { value: 1, name: "AFaire", label: "À faire", css: "badge-light", icon: "fa-circle" },
    { value: 2, name: "EnCours", label: "En cours", css: "badge-primary", icon: "fa-play-circle" },
    { value: 3, name: "Bloquee", label: "Bloquée", css: "badge-danger", icon: "fa-ban" },
    { value: 4, name: "Terminee", label: "Terminée", css: "badge-success", icon: "fa-check-circle" },
];

export const TYPES_JOURNAL = [
    { value: 1, name: "Note", label: "Note", icon: "fa-sticky-note", color: "#6c757d" },
    { value: 2, name: "Incident", label: "Incident", icon: "fa-exclamation-triangle", color: "#dc3545" },
    { value: 3, name: "Reunion", label: "Réunion", icon: "fa-users", color: "#007bff" },
    { value: 4, name: "Visite", label: "Visite", icon: "fa-walking", color: "#17a2b8" },
    { value: 5, name: "Meteo", label: "Météo", icon: "fa-cloud-sun-rain", color: "#6f42c1" },
    { value: 6, name: "Livraison", label: "Livraison", icon: "fa-truck", color: "#fd7e14" },
];
export const GRAVITES = [
    { value: 1, name: "Faible", label: "Faible", css: "badge-info" },
    { value: 2, name: "Moyenne", label: "Moyenne", css: "badge-warning" },
    { value: 3, name: "Grave", label: "Grave", css: "badge-danger" },
];

export const CATEGORIES_DEPENSE = [
    { value: 1, name: "Materiaux", label: "Matériaux", icon: "fa-cubes" },
    { value: 2, name: "MainOeuvre", label: "Main-d'œuvre", icon: "fa-hard-hat" },
    { value: 3, name: "SousTraitance", label: "Sous-traitance", icon: "fa-handshake" },
    { value: 4, name: "Location", label: "Location", icon: "fa-truck-pickup" },
    { value: 5, name: "Transport", label: "Transport", icon: "fa-shipping-fast" },
    { value: 6, name: "Autre", label: "Autre", icon: "fa-receipt" },
];

// Libellés des types de documents commerciaux (clé = nom de la classe côté API)
export const DOC_COMMERCIAL_LABELS = {
    DemandeAchat: "Demande d'achat",
    BonCommandeAchat: "BC fournisseur",
    BonReception: "Bon de réception",
    FactureAchat: "Facture d'achat",
    BonRetourAchat: "Retour fournisseur",
    Devis: "Devis",
    BonCommandeVente: "BC client",
    BonLivraison: "Bon de livraison",
    Facture: "Facture de vente",
    BonRetourVente: "Retour client",
};

const finder = (list, fallback) => (v) =>
    v === null || v === undefined || v === "" ? fallback
        : list.find((x) => x.value === Number(v) || x.name === v) || fallback;

export const findType = finder(TYPES, TYPES[3]);
export const findStatut = finder(STATUTS, STATUTS[2]);
export const findPriorite = finder(PRIORITES, PRIORITES[1]);
export const findEtape = finder(ETAPES_VENTE, null);
export const findStatutTache = finder(STATUTS_TACHE, STATUTS_TACHE[0]);
export const findTypeJournal = finder(TYPES_JOURNAL, TYPES_JOURNAL[0]);
export const findGravite = finder(GRAVITES, null);
export const findCategorieDepense = finder(CATEGORIES_DEPENSE, CATEGORIES_DEPENSE[5]);

// ---- Helpers ----
export const unwrap = (res) => (res.data && res.data.data !== undefined ? res.data.data : res.data);
export const apiMessage = (error, fallback) =>
    error.response?.data?.message || error.response?.data?.Message || fallback;
export const toast = (icon, title) =>
    Swal.fire({ toast: true, position: "top-end", icon, title, showConfirmButton: false, timer: 2000 });

export const formatDate = (v) => (v ? new Date(v).toLocaleDateString("fr-FR") : "—");
export const toDateInput = (v) => (v ? String(v).substring(0, 10) : "");
export const formatAmount = (v) =>
    v === null || v === undefined || v === "" ? "—"
        : Number(v).toLocaleString("fr-FR", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " DH";

export const mediaKind = (d) => {
    const ct = (d.contentType || "").toLowerCase();
    const ext = (d.fileName || "").split(".").pop().toLowerCase();
    if (ct.startsWith("image/") || ["jpg", "jpeg", "png", "gif", "webp", "bmp"].includes(ext)) return "image";
    if (ct.startsWith("video/") || ["mp4", "webm", "mov", "avi", "mkv"].includes(ext)) return "video";
    return null;
};

// Badges réutilisables
export const TypeBadge = ({ type }) => {
    const t = findType(type);
    return <span className={`badge ${t.css}`}><i className={`fas ${t.icon} mr-1`}></i>{t.label}</span>;
};
export const StatutBadge = ({ statut }) => {
    const s = findStatut(statut);
    return <span className={`badge ${s.css}`}>{s.label}</span>;
};
export const PrioriteIcon = ({ priorite }) => {
    const p = findPriorite(priorite);
    return <i className={`fas ${p.icon} ${p.css}`} title={`Priorité ${p.label.toLowerCase()}`}></i>;
};
export const ProgressBar = ({ value, enRetard }) => (
    <div className="progress gp-progress" title={`${value ?? 0} %`}>
        <div
            className={`progress-bar ${enRetard ? "bg-danger" : value >= 100 ? "bg-success" : ""}`}
            style={{ width: `${Math.min(100, Math.max(0, value ?? 0))}%` }}
        >
            {value ?? 0}%
        </div>
    </div>
);
